<template>
  <!-- 二维地图功能面板 -->
  <div class="infoPanel" v-show="isDetailOpen">
    <div class="taskContentAll" v-show="open">
      <div class="topWrap">
        <div class="title">
<!--          <div class="closeBtn" @click="changeDetailOpen(false)"></div>-->
          <span>
            飞行详情
          </span>
        </div>

        <div class="TopContent">
<!--          <div class="routeWrap" v-if="planeDetailData.startPoint">-->
          <div class="routeWrap">
            <div>
              {{planeDetailData.startPoint?planeDetailData.startPoint.name.length>=4?planeDetailData.startPoint.name.slice(0, 3)+'...':planeDetailData.startPoint.name:NaN}}
              <span>
                 {{planeDetailData.startPoint?planeDetailData.startPoint.name:NaN}}
              </span>
            </div>
            <div> {{planeDetailData.endPoint?planeDetailData.endPoint.name.length>=4?planeDetailData.endPoint.name.slice(0, 3)+'...':planeDetailData.endPoint.name:NaN}}
              <span>
                 {{planeDetailData.endPoint?planeDetailData.endPoint.name:NaN}}
              </span>
            </div>

          </div>
          <div class="timeWrap">
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">计划起飞时间</div>
                <div class="timeData">15：00</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">计划降落时间</div>
                <div class="timeData">15：00</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">实际起飞时间</div>
                <div class="timeData">15：00</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">实际降落时间</div>
                <div class="timeData">15：00</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomWrap">
        <div class="title">
          <span>
            实时飞行
          </span>
        </div>

        <div class="BottomContent">
          <FlightDetailRealTime
            :clickPlaneInfo="clickPlaneInfo"
            :planeChartData="planeChartData"
            :planeDetailData="planeDetailData"
            :isHistory="isHistory"
            :playOrPause="playOrPause"
            :replaySpeed="replaySpeed"
            :taskPlan="taskPlan"
            :currentPoint="lastPoint"
          ></FlightDetailRealTime>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {wgs84ToGcj02} from "../../../assets/js/map/ConverseLngAndLa";
// import FlightDetailRealTime from "../home/smallModel/flightera.vue"
import FlightDetailRealTime from "./flightera.vue"

export default {
  components:{FlightDetailRealTime},
  props: {
    //是否打开
    isDetailOpen: {
      type: Boolean,
      default: false
    },
    changeDetailOpen: {
      type: Function,
      default: null
    },
    planeChartData: {
      type: Array,
      default: []
    },
    planeDetailData: {
      type: Object,
      default: {}
    },
    clickPlaneInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },

  },
  watch: {
    runTask() {
      this.changeRunTask = this.runTask.map(v => ({
        ...v,
        startChecked: false,
        changeChecked: false,
        downChecked: false
      }))
    }
  },

  data() {
    return {
      isHistory: false, //是否是历史详情
      playOrPause: false, //暂停或播放轨迹
      replaySpeed: 1, //轨迹回放倍数
      lastPoint: { heading: 180, roll: 0, pitch: 0 }, //最后一个点信息
      taskPlan: {}, //计划信息
      // 存储被点击的id
      startIds: [],
      changeIds: [],
      downIds: [],

      //处理之后的数据
      changeRunTask: [],

      // active1: false,
      // active2: false,
      // active3: false,
      // active4: false,
      // active5: false,
      // active6: false,
      open: true,
      openDetail: true,
      searchEvent: '',
      searchRealTask: '',
      searchPreTask: '',

    };
  },
  mounted() {
  },
  methods: {
    getTargetTimeStr(v){
      const date = new Date(v);
      const hours = String(date.getHours()).padStart(2, '0'); // 确保两位数
      const minutes = String(date.getMinutes()).padStart(2, '0'); // 确保两位数
      return`${hours}:${minutes}`;
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

body {
  overflow-x: hidden
}
.timeWrap{
  height: calc(100% - 50px);
  //overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.timeWrap .timeSeparate{
    background-image: url("../../../assets/img/2dmap/under_bg.png");
    width: 299px;
    height: 18px;
}
.timeWrap .timeData{
  font-size: 22px;
  font-family: zcoolwenyiti, zcoolwenyiti-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}
.routeWrap {
  margin-top: 12px;
  //width: 299px;
  width: calc(100% - 20px);
  height: 28px;
  background-image: url("../../../assets/img/2dmap/qi_zhong_dian.png");
  background-size: 100% 100%;
  //padding: 34% 10% 38% 10%;
  //padding: 0 5px 8px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.topWrap {
  //width: 100%;
  height: 35%;
  width: 100%;
  padding: 0 10px 0px 10px;
}
.bottomWrap{
  flex: 728;
  display: flex;
  flex-direction: column;
}

.routeWrap > div {
  position: relative;
  white-space: nowrap;
  height: 20px;
  width: 80px;
  font-size: 20px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 8px;
}

.routeWrap > div > span {
  display: none;
  font-size: 16px;
  position: absolute;
  color: #fff;
  top: -30px;
  left: -10px;
  z-index: 1003;
}

.routeWrap > div:hover > span {
  display: block;
}


.timeGroup {
  font-size: 16px;
  width: 100%;
}

.timeItem {
  width: 299px;
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #FFFFFF;
}

.timeItem .timeKey {
  font-size: 16px;
  color: #ebebeb;
}

.timeItem .time {
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
}
.BottomContent{
  box-sizing: border-box;
  padding: 0 18px 0 18px;
  min-width: 346px;
  flex:1;
  //background: rgba(23,11,1,0.50);
  border-radius: 6px;
  margin-top: 2px;
}

.infoPanel {
  height: 100%;
  overflow: auto;
  min-width:346px;
  //width: auto;
  //position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* overflow-y: auto; */
}

.open {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 10px;
  width: 38px;
  height: 38px;
  background: rgba(15, 86, 115, 0.4);
}

.open img {
  width: 38px;
  height: 38px;
  //margin: 7px;
}

.taskContentAll {
  overflow: auto;
  box-sizing: border-box;
  //border: 1px solid red;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column; /* 子元素垂直排列 */
  flex: 1; /* 每列平分父元素宽度 */
  display: -webkit-flex;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //background: rgba(15, 86, 115, 0.2);
}


.title {
  height: 46px;
  background-image: url("../../../assets/img/2dmap/pop_bg.png");
  background-size: 80% 38px;
  background-position: bottom left;
  background-repeat: no-repeat;
  padding-left: 27px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  padding-top: 6px;
  box-sizing: border-box;
}


.topWrap .TopContent {
  width: 100%;
  height: calc(100% - 50px);
  background: rgba(1,10,18,0.50);
  display: flex;
  flex-direction: column;
  align-items: center;
}



/* @-webkit-keyframes */
@keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}

.heiti {
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  text-align: left;
  color: #ffffff;
}

.zhengDao {
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  text-align: left;
  color: #ffffff;
}

.blinking {
  -webkit-animation-name: blinker;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
  -webkit-animation-duration: 1s;
  animation-name: blinker;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
  animation-duration: 1s;
}
</style>







// WEBPACK FOOTER //
// src/components/dashboard/components/PlanDetail.vue